import { Box } from '@mui/material'
import ContactHeroSection from '../components/contact/ContactHeroSection'
import ContactInfoCards from '../components/contact/ContactInfoCards'
import ContactForm from '../components/common/ContactForm'
import ContactSocialSection from '../components/contact/ContactSocialSection'
import { contactInnerSx, contactSectionWrapperSx } from '../components/contact/contactLayout'

export default function ContactPage() {
  return (
    <Box sx={{ bgcolor: '#fffefa' }}>
      <ContactHeroSection />

      <Box sx={{ ...contactSectionWrapperSx, pb: { xs: 8, md: 12, lg: '150px' } }}>
        <Box sx={contactInnerSx}>
          <ContactInfoCards />
          <ContactForm />
          <ContactSocialSection />
        </Box>
      </Box>
    </Box>
  )
}
